import React, { useState, useEffect } from 'react';
import estilo from './index.module.scss';
import OperacoesTabela from './OperacoesTabela';
import BarraAcoes from './BarraAcoes';
import { useObrigacoes } from '../../hooks/useObrigacoes';
import { useGovernancaContext } from '../../../../../context/GovernancaContext';
import Lottie from 'lottie-react';
import LoadingListaObrigacoes from '../../../../../assets/loadings/CarregandoListaObrigacoes.json';

const OperacoesEmMassa: React.FC = () => {
	const { empresaAtiva } = useGovernancaContext();
	const { obrigacoes, fetchObrigacoes, handleObrigacaoChange } = useObrigacoes();
	const [obrigacoesSelecionadas, setObrigacoesSelecionadas] = useState<number[]>([]);
	const [mostrarSelecionados, setMostrarSelecionados] = useState(false);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const carregarDados = async () => {
			setLoading(true);

			const fetchPromise = fetchObrigacoes();

			const delay = new Promise((resolve) => setTimeout(resolve, 1000));

			await Promise.all([fetchPromise, delay]);

			setLoading(false);
		};

		carregarDados();
	}, [fetchObrigacoes]);

	const aoAlterarSelecao = (selecionadas: number[]) => {
		setObrigacoesSelecionadas(selecionadas);
	};

	const atualizarInterface = async () => {
		setLoading(true);

		const fetchPromise = fetchObrigacoes();
		const delay = new Promise((resolve) => setTimeout(resolve, 3000));
		await Promise.all([fetchPromise, delay]);

		setLoading(false);
	};

	return (
		<div className={estilo.operacoesEmMassaContainer}>
			{loading ? (
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
					<Lottie loop animationData={LoadingListaObrigacoes} style={{ width: '30%', height: '50%' }} />
				</div>
			) : (
				<>
					<h1>Obrigações</h1>
					<BarraAcoes
						empresaId={empresaAtiva || ''}
						obrigacoesSelecionadas={obrigacoesSelecionadas}
						onSelectChange={aoAlterarSelecao}
						setMostrarSelecionados={setMostrarSelecionados}
						aoAtualizar={atualizarInterface}
					/>
					<OperacoesTabela
						empresaId={empresaAtiva || ''}
						obrigacoes={obrigacoes}
						onObrigacaoChange={handleObrigacaoChange}
						onAtualizar={atualizarInterface}
						onSelectChange={aoAlterarSelecao}
						loading={loading}
					/>
				</>
			)}
		</div>
	);
};

export default OperacoesEmMassa;
